import { useState } from 'react';
import { ComponentPhoto } from '../data/componentPhotos';
import { useI18n } from '../i18n/LanguageContext';

export default function ComponentGallery({ photos, category }: { photos: ComponentPhoto[]; category: string }) {
  const { t } = useI18n();
  const [selected, setSelected] = useState(0);
  const photo = photos[selected];
  return <section className="componentGallery" aria-label={t(category)}>
    <img className="componentGalleryMain" src={photo.src} srcSet={photo.srcSet} sizes="(max-width: 760px) 92vw, (max-width: 1400px) 46vw, 620px" width={1200} height={800} alt={t(photo.label)} loading="lazy"/>
    <div className="componentGalleryControls">
      <div className="componentThumbnails">{photos.map((item, index) => <button type="button" key={item.src} aria-label={t(item.label)} aria-pressed={selected === index} onClick={() => setSelected(index)} title={t(item.label)}><img src={item.src} srcSet={item.srcSet} sizes="60px" width={60} height={40} alt="" loading="lazy"/></button>)}</div>
      <span className="componentGalleryCaption" aria-live="polite">{t(photo.label)}<small>{selected + 1} / {photos.length}</small></span>
    </div>
  </section>;
}
